import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { alloy } from '../colors';

var Circle =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Circle, _PureComponent);

  function Circle() {
    _classCallCheck(this, Circle);

    return _possibleConstructorReturn(this, _getPrototypeOf(Circle).apply(this, arguments));
  }

  _createClass(Circle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          className = _this$props.className,
          color = _this$props.color,
          outline = _this$props.outline,
          outlineWidth = _this$props.outlineWidth;
      return React.createElement("svg", {
        className: className,
        fill: color,
        stroke: outline,
        strokeWidth: outlineWidth,
        width: width,
        height: width,
        viewBox: "0 0 18 18"
      }, React.createElement("circle", {
        cx: "9",
        cy: "9",
        r: "8"
      }));
    }
  }]);

  return Circle;
}(PureComponent);

export { Circle as default };
Circle.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  outline: PropTypes.string,
  width: PropTypes.number,
  outlineWidth: PropTypes.string
};
Circle.defaultProps = {
  color: '',
  outline: alloy,
  className: 'default',
  width: 14,
  outlineWidth: '1px'
};